<template>
  <article class="HomePageMargin" ref="tariffRef">
    <section class="TextCol">
      <div class="SpaceTop" />
      <div class="Subtitle">{{ $t('pricing.small_header') }}</div>
      <div class="Title">{{ $t('pricing.big_header') }}</div>
      <div class="Text">
        <div
          v-if="!$t('pricing.txt1').includes('pricing.txt')"
          style="margin-top: 1em;"
        >
          {{ $t('pricing.txt1') }}
        </div>
        <div
          v-if="!$t('pricing.txt2').includes('pricing.txt')"
          style="margin-top: 1em;"
        >
          {{ $t('pricing.txt2') }}
        </div>
        <div
          v-if="!$t('pricing.txt3').includes('pricing.txt')"
          style="margin-top: 1em;"
        >
          {{ $t('pricing.txt3') }}
        </div>
        <div
          v-if="
            currentTariff.night.maxSignificand &&
              !$t('pricing.txt4').includes('pricing.txt')
          "
          style="margin-top: 1em;"
        >
          {{ $t('pricing.txt4') }}
        </div>
        <div style="margin-top: 1em;">
          {{ $t('pricing.subtxt') }}
        </div>
      </div>
    </section>
    <Tariffs :updateCurrentCity="updateCurrentCity" />
  </article>
</template>

<script>
import tariffs from '@/data/tariffs.json';
import { entity } from '../../../region.json';
import Tariffs from '../shared/Tariffs.vue';

export default {
  name: 'Pricing',
  props: ['tariffRef'],
  components: { Tariffs },
  data() {
    return {
      entity,
      tariffs: tariffs[entity],
      currentCity: tariffs[entity].cities[0],
    };
  },
  mounted() {
    this.tariffRef[0] = this.$refs.tariffRef;
  },
  computed: {
    currentTariff() {
      const tariff = this.tariffs.data.find(({ city }) => {
        return city === this.currentCity;
      })?.tariff;
      return tariff;
    },
  },
  methods: {
    updateCurrentCity(city) {
      this.currentCity = city;
    },
  },
};
</script>

<style scoped>
.PricingParent {
  display: block;
}

.buttonParent {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* apply margin only to first button */
.buttonParent > div:nth-of-type(1) {
  margin-right: 2em;
}
.buttonParent > button {
  font-weight: normal;
}
.City {
  font-size: var(--city-btn-f-size);
  color: #2b4047;
}
.City {
  outline: none;
}
.UnderLine {
  height: 5px;
  width: 100%;
  border-bottom: 2px solid #c8d1d3;
  border-radius: 15px;
}

.City[data-selected='true'] > .UnderLine {
  border-bottom: 5px solid #ffdf22;
}
.City[data-selected='true'] {
  font-weight: bold;
}

.InnerParent {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

article {
  --day-bg: #ffffff;
  --day-color: #2b4047;
  --day-time-text-color: #5e7177;
  --day-title-color: #2b4047;
  --night-bg: #2b4047;
  --night-color: #ffffff;
  --night-time-text-color: #a1b1b5;
  --night-title-color: #ffffff;
  --price-title-f-size: 24px;
  --price-title-margin: 12px;
  --rect-h: 266px;
  --rect-w: 200px;
  --day-margin-right: 0;
  --day-margin-bottom: 1.5em;
  --space-top: 92px;
  --space-bottom: 70px;
  --text-color: #41565d;
  --max-f-size: 14px;
  --time-f-size: 14px;
  --time-margin: 3px;
  --metrics-f-size: 20px;
  --details-f-size: 10px;
  --subtitle-margin: 32px;
  --subtitle-f-size: 16px;
  --title-margin: 32px;
  --title-f-size: 30px;
  --text-margin: 64px;
  --text-f-size: 14px;
  --price-grid-margin: 26px;
  --grid-gap: 4px;
  --charge-svg-size: 100%;
  --metrics-svg-size: 100%;
  --flex-m-top: 34px;
  --underline-width: 80px;
  --city-btn-f-size: 14px;
}
.TextCol,
.PricingCol {
  margin: 0 auto;
  flex-direction: column;
}
.PricingCol {
  max-width: 100%;
}
.SpaceTop {
  height: var(--space-top);
}
.SpaceBottom {
  height: var(--space-bottom);
}

.Subtitle {
  font-size: var(--subtitle-f-size);
  color: var(--day-time-text-color);
  letter-spacing: 2.4px;
  margin-bottom: var(--subtitle-margin);
}
.Title {
  line-height: normal;
  font-size: var(--title-f-size);
  font-family: Foco;
  color: var(--night-bg);
  font-weight: bold;
  margin-bottom: var(--title-margin);
}
.Text {
  font-size: var(--text-f-size);
  color: var(--text-color);
  margin-bottom: var(--text-margin);
}
.PricingRect {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: var(--rect-h);
  padding: 1em;
  width: var(--rect-w);
  box-shadow: 0px 7px 20px #0033;
  border-radius: 8px;
}
.Flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--flex-m-top);
  flex-direction: column;
}
.Day {
  background: var(--day-bg);
  margin-right: var(--day-margin-right);
  margin-bottom: var(--day-margin-bottom);
}
.Day > img {
  max-width: 38px;
}
.Night {
  background: var(--night-bg);
}
.Night > img {
  max-width: 39px;
}
.DayTitle,
.NightTitle {
  font-weight: bold;
  font-size: var(--price-title-f-size);
  font-family: Foco;
  line-height: normal;
  margin-top: var(--price-title-margin);
}
.DayTitle {
  color: var(--day-title-color);
}
.NightTitle {
  color: var(--night-title-color);
}
.DayTime,
.NightTime {
  font-size: var(--time-f-size);
  margin-top: var(--time-margin);
}
.DayTime {
  color: #5e7177;
}
.NightTime {
  color: #a1b1b5;
}
.PriceGrid {
  display: grid;
  grid-template-areas: 'charge kw' 'time min' '. max';
  align-items: center;
  grid-gap: var(--grid-gap);
  margin-top: var(--price-grid-margin);
  grid-template-columns: 14px auto;
}
.ChargeSvg {
  grid-area: charge;
  width: var(--metrics-svg-size);
}
.TimeSvg {
  grid-area: time;
  width: var(--metrics-svg-size);
}
.kW {
  grid-area: kw;
}
.min {
  grid-area: min;
}
.kW,
.min {
  font-size: var(--metrics-f-size);
}
.Day .kW,
.Day .min {
  color: #2b4047;
}
.Night .kW,
.Night .min {
  color: #ffffff;
}
.max {
  grid-area: max;
  font-size: var(--max-f-size);
  color: #a1b1b5;
  margin-top: -0.3em;
}
.Details {
  color: #a1b1b5;
  letter-spacing: 0.16px;
  font-size: var(--details-f-size);
  max-width: calc((var(--rect-w) * 2) + var(--day-margin-right));
  margin: 1.6em auto 0 auto;
}
.Details div:first-child {
  margin-bottom: 1em;
}

@media (min-width: 400px) {
  .PricingCol {
    max-width: 85%;
  }
}
@media (min-width: 500px) {
  article {
    --rect-w: 172px;
    --rect-h: 244px;
    --price-title-f-size: 19px;
    --time-f-size: 11px;
    --metrics-f-size: 13px;
    --max-f-size: 12px;
    --space-bottom: 120px;
    --day-margin-right: 1em;
    --day-margin-bottom: 0;
  }
  .PriceGrid {
    grid-template-columns: 18px auto;
  }
  .TextCol {
    max-width: 85%;
    margin: 0;
  }
  .Flex {
    justify-content: center;
    flex-direction: row;
    align-items: stretch;
  }
}
@media (min-width: 880px) {
  article {
    display: grid;
    grid-template-columns: 1fr 1fr;
    --min-height: 100%;
    --space-bottom: 0px;
    margin-bottom: 5em;
    margin-top: 6em;
    --underline-width: 104px;
    --city-btn-f-size: 20px;
  }
  .PricingCol {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    max-width: 100%;
    margin: 0;
  }
  .TextCol {
    max-width: 100%;
    margin: 0;
  }
  .Flex {
    justify-content: flex-end;
  }

  .Details {
    align-self: flex-end;
    margin: 1.6em 0 0 0;
  }
}
@media (min-width: 1026px) {
  article {
    --subtitle-f-size: 20px;
    --title-f-size: 30px;
    --text-f-size: 16px;
    --space-bottom: 0px;
    --details-f-size: 12px;
  }
  .Title,
  .Text {
    max-width: 95%;
  }
}
@media (min-width: 1271px) {
  article {
    --title-f-size: 50px;
    --text-f-size: 17px;
    --rect-h: 285px;
    --rect-w: 201px;
    --price-title-f-size: 22px;
    --time-f-size: 13px;
    --metrics-f-size: 16px;
  }
  .PricingRect {
    padding-top: 30px;
  }
  .Day > img {
    max-width: 100%;
    width: 58px;
  }
  .Night > img {
    max-width: 100%;
    width: 58px;
  }
  .PriceGrid {
    grid-template-columns: 18px auto;
  }
  .Title {
    line-height: 1.3;
  }
  .Title,
  .Text {
    max-width: 90%;
  }
}

@media (min-width: 1350px) {
  article {
    --rect-h: 342px;
    --rect-w: 241px;
    --price-title-f-size: 26px;
    --time-f-size: 16px;
    --metrics-f-size: 19px;
    --price-title-margin: 22px;
    --max-f-size: 18px;
    --details-f-size: 16px;
  }
  .PriceGrid {
    grid-template-columns: 22px auto;
  }
  .Title {
    line-height: 1.2;
  }
  .max {
    margin-top: -0.5em;
  }
}

@media (min-width: 1750px) {
  article {
    --title-f-size: 70px;
    --text-f-size: 20px;
    --subtitle-margin: 40px;
    --title-margin: 60px;
    --rect-h: 446px;
    --rect-w: 314px;
    --price-title-f-size: 30px;
    --price-title-margin: 35px;
    --time-f-size: 20px;
    --time-margin: 4px;
    --metrics-f-size: 28px;
    --max-f-size: 24px;
    --price-grid-margin: 45px;
    --grid-gap: 8px;
    --day-margin-right: 2.8em;
    --flex-m-top: 92px;
    margin-top: 4em;
    margin-bottom: 6em;
  }
  .PricingCol {
    justify-content: center;
  }
  .PriceGrid {
    grid-template-columns: 32px auto;
  }
  .Title {
    line-height: 1.3;
    max-width: 90%;
  }
  .Text {
    max-width: 90%;
  }
  .PricingRect {
    padding-top: 40px;
  }
  .Day > img {
    max-width: 100%;
    width: 76px;
  }
  .Night > img {
    max-width: 100%;
    width: 78px;
  }
}
.Cities {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
}
</style>
